import { useAuthContext } from '../contexts/AuthContext';

/**
 * Custom hook for authentication functionality
 * Provides convenient methods for auth operations
 */
export const useAuth = () => {
  const context = useAuthContext();

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  const {
    user,
    isLoading,
    isAuthenticated,
    register,
    login,
    logout,
    updateProfile,
    hasRole,
    hasAnyRole,
  } = context;

  // Convenience methods
  const isViewer = () => hasRole('viewer');
  const isCreator = () => hasRole('creator');
  const isBrand = () => hasRole('brand');
  const isGuildMember = () => hasRole('guild_member');
  const isAdmin = () => hasRole('admin');

  const canCreateContent = () => hasAnyRole(['creator', 'admin']);
  const canManageUsers = () => hasAnyRole(['admin']);
  const canAccessGuild = () => hasAnyRole(['guild_member', 'admin']);
  const canPartnerWithBrands = () => hasAnyRole(['creator', 'brand', 'admin']);

  return {
    // Core auth state
    user,
    isLoading,
    isAuthenticated,
    
    // Auth methods
    register,
    login,
    logout,
    updateProfile,
    
    // Role checking
    hasRole,
    hasAnyRole,
    isViewer,
    isCreator,
    isBrand,
    isGuildMember,
    isAdmin,
    
    // Permission helpers
    canCreateContent,
    canManageUsers,
    canAccessGuild,
    canPartnerWithBrands,
  };
};

export default useAuth;